<template>
  <div class="warp">
    <BaseHeader />
    <main> 
        <PaymentSuccessLeft page="paymentSuccess" />

        <div id="payment"> 
            <a class="btn titillium-sm" @click="close_window" style="padding-right: 46px;">{{ text.closed }}  </a>
         </div>
    </main>
  </div>
</template>

<script>
import PaymentSuccessLeft from '../components/PaymentSuccessLeft.vue';

export default {
    mounted() {
        if (sessionStorage.getItem('linkcode') || localStorage.linkcode == this.$route.query.linkcode) {
        }else{
          this.$router.push(`/authen/?linkcode=${this.$route.query.linkcode}`)
        }
    },
    data() {
        return {};
    },
    created() { 
        if (this.$route.query.deeplink == 1) {
            setInterval(() => {
                if (this.$route.name == 'paymentSuccess') {
                    this.$store.dispatch('getBillData', {linkcode:this.$route.query.linkcode,page:'paymentmethods'})
                }
            }, 1500);
        }else{ 
            setTimeout(() => { 
                this.$store.dispatch('getBillData',{linkcode:this.$route.query.linkcode,page:'paymentsuccess'});
            }, 3000);
        }
     },
    methods: { 
        close_window() {
            window.close(``, `_parent`, ``);
        },
        toDigit(num) {
            return this.twoDecimal(num)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        twoDecimal(val) {
            return parseFloat(val).toFixed(2);
        },
      checkRedirectUrl() {
          let res = false
          if (
            this.$store.state.backUrl != null &&
            this.$store.state.backUrl != ''
          ) {
            res = true
          } else {
            res = false
          }
          return res
        }
    },
    computed: {
        paid() {
            let res = false;
            if (this.$store.state.billData) {
                if (this.$store.state.billData.outstanding == 0) {
                    res = true;
                }
            }
            return res;
        },
        text() {
            let obj = {};
            if (this.$store.state.language == 'TH') {
                obj = {
                    success: 'ชำระเงินสำเร็จ!',
                    text1: this.paid
                        ? 'ท่านได้ชำระเงินเรียบร้อยแล้ว'
                        : 'ท่านยังมียอดคงเหลือที่ต้องชำระ',
                    clickhere: 'คลิกที่นี่',
                    text2: this.paid
                        ? 'เพื่อรับเอกสารการรับชำระ'
                        : 'เพื่อทำการชำระเงินต่อ',
                };
            }
            else {
                obj = {
                    success: 'Success!',
                    text1: this.paid
                        ? 'Payment Successful'
                        : 'You have an outstanding balance to be paid',
                    clickhere: 'Click here',
                    text2: this.paid
                        ? 'to receive payment documents'
                        : 'to continue payment',
                };
            }
            return obj;
        }, 
        text() {
          let obj = {}
          if (this.$store.state.language == 'TH') {
            obj = { 
              closed:'ปิด',
            }
          } else {
            obj = { 
              closed:'Close',
            }
          }
          return obj
        },
        custname() {
            return this.$store.state.name;
        },
        total() {
            return this.twoDecimal(this.$store.state.total)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        paid() {
            return this.$store.state.paid;
        },
        outstanding() {
            return this.$store.state.outstanding;
        },
        ref1() {
            return this.$store.state.ref1;
        },
        billPayment() {
            return this.$store.state.billPayment ? this.$store.state.billPayment : [];
        },
    },
    components: { PaymentSuccessLeft }
}
</script>
 